import { toTruthyList } from 'utils/array';

const MIN_LENGTH = 10;

// We need at least a word with 4 chars
const HIGH_WORD_MIN_LENGTH = 4;
const MIN_WORDS = 3;
const MIN_WORDS_LENGTH = 2;

function hasMoreThan2SameSequentialChars(text: string) {
  const MAX_REPEAT = 2;

  const repeatRegex = new RegExp(`(.)\\1{${MAX_REPEAT},}`);

  return repeatRegex.test(text);
}

export function isValidJustification(justification: string) {
  const trimmed = justification.trim();

  // remove multi spaces like  these <=
  const ref = trimmed.replace(/[^a-zA-Z\s]/g, '').replace(/\s+/g, ' ');

  const words = toTruthyList(ref.split(/\s+/));

  const isValid = [
    ref.length >= MIN_LENGTH,

    words.some((word) => word.length >= HIGH_WORD_MIN_LENGTH),
    words.filter((word) => word.length >= MIN_WORDS_LENGTH).length >= MIN_WORDS,

    !hasMoreThan2SameSequentialChars(ref),
  ].every(Boolean);

  return isValid;
}
